import type { DropdownItemBase } from '@/components/Autocomplete/autocomplete.types';

type ValidReferenceResult = {
	__typename: 'ReferenceResult';
	results: Array<Pick<DropdownItemBase, 'id' | 'name' | 'localizedName'>>;
};

export const isReferenceResults = (
	data: unknown
): data is ValidReferenceResult =>
	typeof data === 'object' &&
	data !== null &&
	'__typename' in data &&
	data.__typename === 'ReferenceResult' &&
	'results' in data;
